<template>
  <!-- <div class="img-preview"> -->
  <image-preview
    v-model:show="show"
    :images="extractImageUrls(imageList)"
    :startPosition="previewIndex"
    :showIndex="showIndex"
    :loop="false"
    @change="onChange"
    @close="onClose"
    :overlayStyle="{ background: 'rgba(0,0,0,0.75)' }"
  >
    <template v-slot:index>{{ currentIndex + 1 + '/' + imageList.length }}</template>
  </image-preview>
  <!-- </div> -->
</template>
<script lang="ts" setup>
import { ref, watch } from 'vue'
import { ImagePreview } from 'vant'

const props = defineProps<{
  previewShow: boolean
  previewIndex: number
  imageList: string[]
  showIndex?: boolean // 是否显示页数
}>()

const currentIndex = ref(props.previewIndex || 0)
const show = ref(props.previewShow)
const emits = defineEmits(['closePreview'])

const extractImageUrls = (imageList: string[]) => {
  const extractedUrls = imageList.map((url) => {
    // 使用正则表达式来提取问号前面的地址
    const match = url.match(/^(.*?)(\?|$)/)
    if (match) {
      return match[1]
    }
    return url
  })
  return extractedUrls
}

watch(
  () => [props.previewShow, props.previewIndex],
  (newVal) => {
    if (newVal[0]) {
      show.value = newVal[0] as boolean
    }
    if (newVal[1]) {
      currentIndex.value = newVal[1] as number
    }
  },
  { immediate: true }
)
const onClose = () => {
  emits('closePreview', false)
}

const onChange = (newIndex: number) => {
  currentIndex.value = newIndex
}
</script>

<style lang="less" scoped>
:deep(.van-image-preview) {
  :deep(.van-image-preview__index) {
    top: 90% !important;
    width: 66px;
    height: 28px;
    opacity: 0.7;
    background: #171921;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

// }
</style>
